interface MarkProps {
  className?: string;
}

export function AnchorMark({ className }: MarkProps) {
  return (
    <svg viewBox="0 0 300 100" className={className}>
      <text x="50%" y="40%" dominantBaseline="middle" textAnchor="middle" fontFamily="'Cormorant Garamond', serif" fontSize="42" fontWeight="600" letterSpacing="0.05em" fill="currentColor">MIRACLE HILL</text>
      <text x="50%" y="75%" dominantBaseline="middle" textAnchor="middle" fontFamily="'Montserrat', sans-serif" fontSize="12" letterSpacing="0.3em" fill="currentColor">DESERT HOT SPRINGS</text>
      <line x1="25%" y1="90%" x2="75%" y2="90%" stroke="currentColor" strokeWidth="1" opacity="0.6" />
    </svg>
  );
}
